__turbopack_context__.v({
  "container": "DropdownMenu-module-scss-module__P4Oxha__container",
  "icon": "DropdownMenu-module-scss-module__P4Oxha__icon",
  "select": "DropdownMenu-module-scss-module__P4Oxha__select",
  "selectHasError": "DropdownMenu-module-scss-module__P4Oxha__selectHasError",
});
